<template>
  <a-card>
    <div style="height: 400px;display: flex;align-items: center;justify-content: center;">
      <a-icon type="exclamation-circle" style="font-size: 20px;color:#ffc53d;margin-right:10px"/>
      <strong style="font-size: 20px;">您 没 有 查 看 权 限</strong>
    </div>
  </a-card>
</template>

<script>
  export default {
      name: "NoAuthority"
  }
</script>

<style scoped>

</style>